import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getVersion = store => store[NAME].version;